<template>
  <div
    :id="`font-picker${pickerSuffix}`"
    class="font-picker"
    :title="state.errorText"
  >
    <button
      class="dropdown-button"
      type="button"
      :class="{ expanded: state.expanded }"
      @click="toggleExpanded"
      @keypress="toggleExpanded"
    >
      <p
        class="dropdown-font-name apply-font"
        :class="`apply-font-${options.name}`"
      >
        {{ state.activeFont }}
      </p>
      <p class="dropdown-icon" :class="state.loadingStatus"></p>
    </button>
    <ul
      v-if="state.loadingStatus === 'finished' && fontManager.fonts"
      :class="{ expanded: state.expanded }"
      @scroll="onScroll"
    >
      <li class="search">
        <input v-model="search" placeholder="Pesquisar..." />
      </li>
      <li
        v-for="(font, index) in filteredWebsafeFonts"
        :key="font + index + pickerSuffix"
      >
        <button
          type="button"
          :style="`font-family: ${font}`"
          :class="font === state.activeFont ? 'active-font' : ''"
          @click="setWebsafeFont(font)"
          @keypress="setWebsafeFont(font)"
        >
          {{ font }}
        </button>
      </li>

      <li v-for="font in filteredFonts" :key="font.family">
        <button
          type="button"
          :class="
            `font-${snakeCase(font.family)}${pickerSuffix} ${
              font.family === state.activeFont ? 'active-font' : ''
            }`
          "
          @click="customItemClick(font)"
          @keypress="customItemClick(font)"
        >
          {{ font.family }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import FontPicker from "font-picker-vue";

export default {
  extends: FontPicker,
  data() {
    return {
      search: "",
      websafeFonts: [
        "sans-serif",
        "Verdana",
        "Tahoma",
        "serif",
        "Georgia",
        "Garamond",
        "monospace",
        "cursive"
      ]
    };
  },
  computed: {
    filteredWebsafeFonts() {
      return this.websafeFonts.filter(
        f => f.toLowerCase().indexOf(this.search.toLowerCase()) > -1
      );
    },
    filteredFonts() {
      return this.fontManager.fonts.filter(
        f => f.family.toLowerCase().indexOf(this.search.toLowerCase()) > -1
      );
    }
  },
  methods: {
    getWebsafeStylesheet() {
      const stylesheetId = `websafe-font${this.pickerSuffix}`;
      let websafeStylesheet = document.getElementById(stylesheetId);
      if (!websafeStylesheet) {
        websafeStylesheet = document.createElement("style");
        websafeStylesheet.id = stylesheetId;
        document.head.appendChild(websafeStylesheet);
      }
      return websafeStylesheet;
    },
    customItemClick(font) {
      this.getWebsafeStylesheet().innerHTML = "";
      this.itemClick(font);
    },
    setWebsafeFont(fontFamily) {
      this.getWebsafeStylesheet().innerHTML = `
        .apply-font${this.pickerSuffix} {
          font-family: ${fontFamily} !important;
        }
      `;
      this.setState({
        activeFont: fontFamily,
        errorText: "",
        loadingStatus: "finished"
      });
      this.toggleExpanded();
      this.$emit("change", { family: fontFamily });
    }
  }
};
</script>
